import moment from 'moment';

export const simpleDateFormat = 'YYYY-MM-DD';
export const simpleDateHourFormat = 'YYYY-MM-DD HH:mm:ss';

// TODO : modify this...
export const IsWeekend = (date: Date | string) => {
  const day = moment(date)
    .locale('fr')
    .format('dddd');
  return day === 'samedi' || day === 'dimanche';
};

export const getWeekDayEnglish = (date: Date | string) => {
  return moment(date)
    .locale('en')
    .format('dddd');
};
